import { Suspense, lazy } from "react";
import Loading from "../components/loading/loading";
import EdgeErrorBoundary from "../components/ErrorBoundary";

const LazyComponent = ({ path }) => {
  const LazyComponent = lazy(() => import(`../screens/${path}`));
  return (
    <EdgeErrorBoundary>
      <Suspense fallback={<Loading />}>
      {/* <Suspense> */}
        <LazyComponent />
      </Suspense>
    </EdgeErrorBoundary>
  );
};

export default LazyComponent;
